import { inject, Injectable } from '@angular/core';
import { Observable,forkJoin, of } from 'rxjs';
import { ProductService } from './product.service';
import { catchError, map } from 'rxjs/operators';
import { ResolveFn } from '@angular/router';

export const productResolver: ResolveFn<any> = (route, state) => {
  const productService = inject(ProductService); 
  return productService.getProducts().pipe(
    map(products => ({ products })),
    catchError((error) => {
      console.error('Error in product resolver', error);
      return of(null); // Return null or some fallback value
    })
  );
};